import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Trash2, Sun, Plus } from "lucide-react";
import { toast } from "sonner";
import { Page, BrandHeader, CloseBtn } from "@/components/Brand";
import { Btn } from "@/components/Btn";
import { useCards, useDeleteCard, usePrefs, useSavePrefs, useToggleCard } from "@/lib/store";

export default function Cards() {
  const navigate = useNavigate();
  const { data: cards } = useCards();
  const { data: prefs } = usePrefs();
  const savePrefs = useSavePrefs();
  const del = useDeleteCard();
  const add = useToggleCard();
  const [own, setOwn] = useState("");
  const list = cards ?? [];

  const addOwn = async () => {
    if (!own.trim()) return;
    await add.mutateAsync({ schema: "My Healthy Adult", title: "My own script", text: own.trim() });
    setOwn("");
    toast.success("Card saved");
  };

  return (
    <Page>
      <BrandHeader right={<CloseBtn onClick={() => navigate(-1)} testId="cards-close" />} />
      <h1 className="mt-8 text-4xl font-bold text-t-on">My script cards</h1>
      <p className="mt-2 text-t-on2">Your Healthy Adult voice, saved for the moments the old script gets loud.</p>
      <div className="mt-6 tf-card p-4 flex flex-col gap-3">
        <p className="tf-tag">Write my own script</p>
        <textarea className="tf-input" value={own} onChange={(e) => setOwn(e.target.value)} placeholder="In my own words, my Healthy Adult says…" data-testid="cards-own-input" />
        <Btn size="md" className="self-start" icon={<Plus size={16} />} label="Save as card" onClick={addOwn} loading={add.isPending} testId="cards-own-save" />
      </div>
      <div className="mt-6 flex flex-col gap-3">
        {list.length === 0 ? (
          <div className="text-center py-10 text-t-muted" data-testid="cards-empty">
            No cards yet. Tap “Save as card” on any adaptive script in Flip the Script.
            <Btn variant="secondary" className="mt-5 mx-auto" label="Open Flip the Script" onClick={() => navigate("/flip")} testId="cards-open-flip" />
          </div>
        ) : list.map((c, i) => {
          const morning = prefs?.affirmationCardId === c.id;
          return (
            <div key={c.id} className={`tf-card p-5 ${morning ? "!border-t-brand" : ""}`} data-testid={`card-${i}`}>
              <p className="tf-tag">{c.title}{morning ? " · morning affirmation" : ""}</p>
              <p className="text-[13px] text-t-muted">{c.schema}</p>
              <p className="mt-2 text-lg text-t-on">“{c.text}”</p>
              <div className="mt-3 flex gap-2">
                <button onClick={() => savePrefs.mutate({ affirmationCardId: morning ? null : c.id })} data-testid={`card-morning-${i}`}
                  className="inline-flex items-center gap-1.5 rounded-full bg-t-brand2 text-t-brand px-3.5 h-9 text-sm font-semibold"><Sun size={15} />{morning ? "Unset affirmation" : "Set as morning affirmation"}</button>
                <button onClick={() => del.mutate(c.id)} data-testid={`card-delete-${i}`} aria-label="Delete card"
                  className="w-9 h-9 rounded-full bg-t-surface3 text-t-on2 grid place-items-center"><Trash2 size={15} /></button>
              </div>
            </div>
          );
        })}
      </div>
    </Page>
  );
}
